const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useProgress } = window.BAO.Carousel.plugins

class CardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.setupBodyAlignment()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.bodyResizeObserver?.disconnect()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.25,
          spacing: 4,
        },
        breakpoints: {
          '(min-width: 600px)': {
            slides: {
              perView: 1.8,
              spacing: 4,
            },
          },
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 4,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.2,
              spacing: 4,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4.2,
              spacing: 4,
            },
          },
        },
        created: slider => this.updateFit(slider),
        updated: slider => this.updateFit(slider),
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  updateFit (slider) {
    const fits = (slider.track?.details?.maxIdx ?? 0) <= 0

    this.els.slides.element.classList.toggle('car-Carousel_Carousel-centred', fits)
    this.els.progress?.element.setAttribute('aria-hidden', fits)
  }

  setupBodyAlignment () {
    if (!this.els.bodyGroup?.exists) return

    this.bodyResizeObserver = new ResizeObserver(() => {
      this.updateBodyAlignment()
    })

    this.els.bodyGroup.elements.forEach(bodyGroup => {
      this.bodyResizeObserver.observe(bodyGroup)
    })

    this.updateBodyAlignment()

    const fontsReady = document.fonts?.ready ?? Promise.resolve()

    fontsReady.then(() => {
      if (!this.isConnected) return

      this.bodyAlignmentCanReveal = true
      this.updateBodyAlignment()
    })
  }

  updateBodyAlignment () {
    const bodyHeight = Math.max(
      ...this.els.bodyGroup.elements.map(bodyGroup => (
        bodyGroup.getBoundingClientRect().height
      )),
    )

    if (!bodyHeight) return

    this.style.setProperty('--CardCarousel_BodyHeight', `${bodyHeight}px`)

    if (this.bodyAlignmentCanReveal) {
      this.classList.add('car-Carousel-bodyAligned')
    }
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel)
}
